import type { RoutesFunc } from 'src/routes/routes';

import { HomePage } from './home-page';

export const routes: RoutesFunc = (_queryClient) => [
  {
    path: '/',
    id: 'home',
    Component: HomePage,
  },
];
